import { Injectable, computed, inject, signal } from '@angular/core';
import {
  AdminBirthdayItem,
  BirthdayAdminService,
} from '@nebalkon-workspace/admin-api';
import { catchError, of } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class StaffBirthdaysService {
  readonly #birthdayApi = inject(BirthdayAdminService);

  readonly employees = signal<AdminBirthdayItem[]>([]);
  readonly clients = signal<AdminBirthdayItem[]>([]);
  readonly loading = signal(false);
  readonly loaded = signal(false);
  readonly error = signal(false);

  readonly employeesCount = computed(() => this.employees().length);
  readonly clientsCount = computed(() => this.clients().length);

  ensureLoaded(): void {
    if (this.loaded() || this.loading()) {
      return;
    }

    this.#load();
  }

  refresh(): void {
    if (this.loading()) {
      return;
    }

    this.#load();
  }

  #load(): void {
    this.loading.set(true);
    this.error.set(false);

    this.#birthdayApi
      .getUpcomingBirthdays({ daysBefore: 3, daysAfter: 3 })
      .pipe(
        catchError(() => {
          this.error.set(true);
          return of(null);
        }),
      )
      .subscribe((response) => {
        this.loading.set(false);
        this.loaded.set(true);
        if (!response) {
          this.employees.set([]);
          this.clients.set([]);
          return;
        }

        this.employees.set(response.employees ?? []);
        this.clients.set(response.clients ?? []);
      });
  }
}
